import LidedeImage from "./lidede.jpg";
import Logo from "./logo.png";
import JuliaImage from "./julia.jpg";
import GoogleImage from "./google.jpeg";
import StudentImage from "./nufta.jpg";
import TeacherImage from "./teacher.jpg";
import LenanaImage from "./lenana.jpg";

export {
  LenanaImage,
  TeacherImage,
  StudentImage,
  GoogleImage,
  JuliaImage,
  Logo,
  LidedeImage,
};
